import { getCsrfToken } from "./constants";

import type { UploadFile } from "antd";

export interface SupportData {
  supportGroup: string;
  product: string;
  subject: string;
  description: string;
  files: UploadFile[];
}

const createSupportRequest = async (formData: FormData): Promise<Response> => {
  const response = await fetch(`/api/zammad/request`, {
    method: "PUT",
    headers: { "X-CSRFToken": getCsrfToken() },
    body: formData,
  });
  return response;
};

export { createSupportRequest };
